import { Component, inject, input } from '@angular/core';

import { AudioService } from '../../../core/services/audio';

@Component({
  selector: 'app-top-app-bar',
  imports: [],
  templateUrl: './top-app-bar.html',
  styleUrl: './top-app-bar.scss',
})
export class TopAppBar {
  private readonly audio = inject(AudioService);

  readonly title = input('Projeto Trivia');
  readonly isSoundEnabled = this.audio.isSoundEnabled;

  protected onToggleSound(): void {
    this.audio.toggleSound();
  }
}
